module.exports = __webpack_public_path__ + "static/media/3_r_podvodi.672dba8e.png";